import {_} from 'lodash';
import * as ko from "knockout";
import {ErrorTracker} from "../../../error.tracker";
import {IRule} from '../../../index';
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {Selections} from "./_def";
import {Settings} from "./Settings";
import {global} from "../../../appContext";
import {nsRuleset} from "../nsRuleset";
import {IWizardParams} from "../index";
import {ButtonManager} from "../../../util/ButtonManager";
import {
    getCancelButton,
    getNextButton,
    getPreviousButton,
    getSubmitButton,
} from "../../../constants/RouteDefinitions";
import RULE_DEFAULT = nsRuleset.RULE_DEFAULT;
import managerHtml from './manager.html?raw';

export let template = managerHtml;

enum Step {
    Selection,
    Exception,
}

export class viewModel {
    private readonly Step = Step;
    private readonly et: ErrorTracker = global.errorAreas.get("rules.wizard");
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly numSteps = Object.keys(Step).length / 2;
    private readonly settings: Settings;
    private readonly step: KnockoutObservable<Step | null> = ko.observable(null);
    private static Title: string = `((wizard for adding rules))`;
    private readonly title: KnockoutObservable<string> = ko.observable(viewModel.Title)
    private readonly pageButtons = new ButtonManager()

    constructor(private params: IWizardParams) {
        this.settings = new Settings(params.availableData, params.mutableRuleset);
        this.kosub.subscribe(this.step, step => {
            if (step == null) {
                return
            }
            this.title(`${viewModel.Title} <span class="name">[${step + 1}/${this.numSteps}]</span>`)
        });
        this.kosub.subscribe(this.settings.selectionType, selectionType => {
            if (selectionType?.value == 'object' && !this.settings.selection()) {
                this.settings.selection(Selections[0] ?? null);
            }
        });

        this.pageButtons.add(getCancelButton(() => this.params.__dialog.close?.()));
        this.pageButtons.add(getPreviousButton({
            label: 'back',
            onClick: () => this.onPreviousClick(),
            enabled: () => !!this.step(),
        }));
        this.pageButtons.add(getNextButton({
            onClick: () => this.onNextClick(),
            enabled: () => !!this.settings.isValid(),
            validator: () => !this.isLastStep(),
        }));
        this.pageButtons.add(getSubmitButton({
            icon: 'fa-check',
            label: 'add',
            onClick: () => this.onCompleteClick(),
            enabled: () => !!this.settings.isValid(),
            validator: () => this.isLastStep(),
        }));

        this.step(Step.Selection);
    }

    private onPreviousClick() {
        const step = this.step()
        if (step == null) {
            return
        }
        this.step(step - 1);
    }

    private onNextClick() {
        const step = this.step()
        if (step == null) {
            return
        }
        this.step(step + 1);
    }

    private isLastStep() {
        return this.step() == this.numSteps - 1;
    }

    private onCompleteClick() {
        this.params.__dialog.callbackFn?.(this.generateRules());
        this.params.__dialog.close?.()
    }

    private generateRules(): IRule[] {
        const ret: Partial<IRule>[] = [];
        if (this.settings.isUserObjects() && this.settings.deletedPreset() === null) {
            ret.push({
                argumentoperator: this.settings.deleted() ? 'Har verdi' : 'Har ikke verdi',
                attribute: 'Deleted',
            })
        }
        const category = this.settings.category()
        if (category?.value == 'manager') {
            ret.push({
                argumentoperator: 'Har verdi',
                attribute: 'ManagerOf',
            });
        }

        return ret
            .concat(
                this.settings.ruleMutableSelection.getRules(),
                this.settings.ruleMutableException.getRules(),
            )
            .map(r => _.defaults(r, RULE_DEFAULT))
            ;
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
